import { type LoadableEntry } from "../../redux/loadableStore/types";
import { useState, useEffect } from "react";

export const useSimpleLoader = <T>(provider: () => Promise<T>, dependencies?: any[]) => {
  const [state, setState] = useState<LoadableEntry<T>>({ state: "loading" });

  useEffect(() => {
    if (state.state !== "loading") {
      setState({ state: "loading" });
    }
    provider()
      .then((data) => setState({ state: "loaded", data }))
      .catch((err) => setState({ state: "error" }));
  }, dependencies);
  return state;
};
